var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.childType,_vm._b({key:_vm.childHash,tag:"component",attrs:{"my-program":_vm.myProgram},on:{"exercise-changed":function($event){return _vm.$emit('exercise-changed')}}},'component',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }